import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { setCookie, getCookie } from 'cookies-next';
import { useSession } from 'next-auth/react';
import { COOKIE_ANON_SESSION_ID } from 'src/constants';

export function useAnonSessionId() {
  const { data: session, status } = useSession();
  const [anonSessionId, setAnonSessionId] = useState<string | null>(null);

  useEffect(() => {
    // Wait until session status is resolved
    if (status === 'loading') return;

    const userId = (session?.user as { userId?: number })?.userId;

    if (userId) {
      setAnonSessionId(`default:${userId}`);
      return;
    }

    // Unauthenticated: use cookie-based uuid
    const existingAnonSessionId = getCookie(COOKIE_ANON_SESSION_ID);
    if (!existingAnonSessionId) {
      const newAnonSessionId = uuidv4();
      void setCookie(COOKIE_ANON_SESSION_ID, newAnonSessionId, {
        secure: true,
        sameSite: 'strict',
      });
      setAnonSessionId(newAnonSessionId);
    } else {
      setAnonSessionId(existingAnonSessionId as string);
    }
  }, [status, session]);

  return anonSessionId;
}
